(function () {
  'use strict';
  if (window.CTLeadBridge && window.CTLeadBridge.version) return;

  var supported = {
    lead_intent: 'lead_intent',
    contact_whatsapp: 'contact_whatsapp',
    choose_payment_plan: 'choose_payment_plan',
    generate_lead: 'generate_lead'
  };
  var attributionKey = 'ct_attribution_v1';

  function safeParse(value) {
    try { return JSON.parse(value || '{}') || {}; } catch (error) { return {}; }
  }

  function readAttribution() {
    var stored = {};
    try { stored = safeParse(window.localStorage.getItem(attributionKey)); } catch (error) {}
    var params = new URLSearchParams(window.location.search || '');
    var keys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'gclid', 'fbclid', 'ttclid'];
    // A new tagged arrival is one touch, not a mix of several historical campaigns.
    var tagged = ['utm_source', 'utm_medium', 'utm_campaign', 'gclid', 'fbclid', 'ttclid'].some(function(key){ return !!params.get(key); });
    if(tagged) keys.forEach(function(key){ delete stored[key]; });
    keys.forEach(function (key) {
      var value = params.get(key);
      if (value) stored[key] = value.slice(0, 300);
    });
    if (!stored.first_landing_page) stored.first_landing_page = window.location.href.slice(0, 500);
    stored.latest_landing_page = window.location.href.slice(0, 500);
    if (!stored.referrer && document.referrer) stored.referrer = document.referrer.slice(0, 500);
    if (!stored.tracking_id) stored.tracking_id = 'ct-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
    try { window.localStorage.setItem(attributionKey, JSON.stringify(stored)); } catch (error) {}
    return stored;
  }

  function populateAttribution(root) {
    var values = readAttribution();
    (root || document).querySelectorAll('[data-ct-attribution]').forEach(function (field) {
      var key = field.getAttribute('data-ct-attribution');
      field.value = values[key] || '';
    });
    return values;
  }

  function clean(value) {
    if (value == null) return value;
    if (typeof value === 'string') return value.trim().slice(0, 500);
    if (Array.isArray(value)) return value.slice(0, 30).map(clean);
    if (typeof value === 'object') {
      var output = {};
      Object.keys(value).slice(0, 40).forEach(function (key) { output[key] = clean(value[key]); });
      return output;
    }
    return value;
  }

  function deliver(name, detail) {
    if (!supported[name]) return;
    var source=readAttribution().utm_source || '';
    if(source === 'codex_qa' || source === 'codex_test') return;
    var payload = clean(detail || {});
    if (typeof window.gtag === 'function') window.gtag('event', supported[name], payload);
    if (typeof window.fbq === 'function') {
      if (name === 'generate_lead') window.fbq('track', 'Lead', payload);
      else if (name === 'contact_whatsapp') window.fbq('track', 'Contact', payload);
      else if (name === 'lead_intent') window.fbq('trackCustom', 'LeadIntent', payload);
    }
  }

  function attach() {
    var layer = window.ChinaTourlyEvents;
    if (!layer || typeof layer.emit !== 'function') return false;
    if (layer.deliveryVersion) return true;
    if (layer.__ctLeadBridgeAttached) return true;
    var originalEmit = layer.emit;
    layer.emit = function (name, detail, options) {
      var result = originalEmit.call(layer, name, detail, options);
      if (result) deliver(name, result.detail || detail);
      return result;
    };
    layer.__ctLeadBridgeAttached = true;
    layer.deliveryVersion = '1.1.0';
    return true;
  }

  var attempts = 0;
  function boot() {
    populateAttribution(document);
    if (attach() || attempts++ >= 40) return;
    window.setTimeout(boot, 250);
  }

  document.addEventListener('submit', function (event) {
    if (event.target && event.target.matches && event.target.matches('#ct-inquiry-form-v3')) populateAttribution(event.target);
  }, true);
  document.addEventListener('shopify:section:load', function (event) { populateAttribution(event.target); });

  window.CTLeadBridge = { version: '1.3.0', deliver: deliver, attribution: readAttribution };
  boot();
})();
